import script from "./ScheduleNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleNav.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleNav.vue?vue&type=style&index=0&id=5f88edaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f88edaa"]])

export default __exports__